"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _baseColors = _interopRequireDefault(require("../baseColors"));

var _baseColors2 = _interopRequireDefault(require("./baseColors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var badge = {
  "default": {
    text: _baseColors["default"]["default"],
    menuText: _baseColors["default"]["default"],
    icon: 'default',
    border: _baseColors["default"]["default"],
    background: _baseColors["default"].white,
    hoverBackground: _baseColors["default"].ghostGrey
  },
  high: {
    text: _baseColors["default"].vermilion,
    menuText: _baseColors["default"].vermilion,
    icon: 'vermilion',
    border: _baseColors["default"].vermilion,
    background: _baseColors["default"].white,
    hoverBackground: _baseColors["default"].ghostGrey
  },
  medium: {
    text: _baseColors["default"].princetonOrange,
    menuText: _baseColors["default"].vermilion,
    icon: 'princetonOrange',
    border: _baseColors["default"].princetonOrange,
    background: _baseColors["default"].white,
    hoverBackground: _baseColors["default"].ghostGrey
  },
  low: {
    text: _baseColors["default"].kellyGreen,
    menuText: _baseColors["default"].kellyGreen,
    icon: 'kellyGreen',
    border: _baseColors["default"].kellyGreen,
    background: _baseColors["default"].white,
    hoverBackground: _baseColors["default"].ghostGrey
  },
  neutral: {
    text: _baseColors["default"].darkCerulean,
    menuText: _baseColors["default"].darkCerulean,
    icon: 'darkCerulean',
    border: _baseColors["default"].darkCerulean,
    background: _baseColors["default"].white,
    hoverBackground: _baseColors["default"].ghostGrey
  },
  active: {
    text: _baseColors["default"].white,
    menuText: _baseColors["default"].activeGreen,
    icon: 'white',
    border: _baseColors["default"].activeGreen,
    background: _baseColors["default"].activeGreen
  },
  archived: {
    text: _baseColors["default"].white,
    menuText: _baseColors["default"].archivedGrey,
    icon: 'white',
    border: _baseColors["default"].archivedGrey,
    background: _baseColors["default"].archivedGrey
  },
  pending: {
    text: _baseColors["default"].white,
    menuText: _baseColors["default"].pendingOrange,
    icon: 'white',
    border: _baseColors["default"].pendingOrange,
    background: _baseColors["default"].pendingOrange
  },
  tag: {
    text: _baseColors2["default"].black,
    background: _baseColors["default"].lightGray
  }
};
var _default = badge;
exports["default"] = _default;